import { Box, LinearProgress, Typography } from '@mui/material';
import { formatCurrency } from '../../../../../utils/format';
import { percentOf } from './amendment-detail-form-utils';

// Barra de execução financeira (ex.: liquidado de empenhado); fica vermelha quando ultrapassa o total
export function ProgressStat({ label, current, total, color = 'primary' }: {
    label: string; current: number; total: number; color?: 'primary' | 'success' | 'warning';
}) {
    const percent = percentOf(current, total);
    const exceeded = total > 0 && current > total;
    return (
        <Box sx={{ mb: 1.5, '&:last-of-type': { mb: 0 } }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5, gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>{label}</Typography>
                <Typography variant="caption" sx={{ whiteSpace: 'nowrap', fontWeight: exceeded ? 700 : 400, color: exceeded ? 'error.main' : 'text.secondary' }}>
                    {percent.toFixed(0)}%
                </Typography>
            </Box>
            <LinearProgress variant="determinate" value={Math.min(100, percent)} color={exceeded ? 'error' : color} sx={{ height: 6, borderRadius: 3 }} />
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                {formatCurrency(current)} de {formatCurrency(total)}
            </Typography>
        </Box>
    );
}

export function ProgressSummary({ children }: { children: React.ReactNode }) {
    return <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'background.default' }}>{children}</Box>;
}

// Barra compacta usada nos painéis aninhados das tabelas
export function InlineProgress({ current, total, color = 'primary' }: { current: number; total: number; color?: 'primary' | 'success' }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <LinearProgress variant="determinate" value={Math.min(100, percentOf(current, total))} color={color} sx={{ flex: 1, height: 6, borderRadius: 3 }} />
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                {formatCurrency(current)} de {formatCurrency(total)}
            </Typography>
        </Box>
    );
}
